import { QueryHookOptions, useQuery } from "@apollo/client";
import { graphql } from "~/gql";
import { FindAccruedFeesForUserQuery } from "~/gql/graphql";
import { MatterStatus } from "../__generated_types__/globalTypes";

export const FIND_ACCRUED_FEES_FOR_USER = graphql(/* GraphQL */ `
  query findAccruedFeesForUser($filter: AccruedFeeForUserPagination!) {
    __typename
    findAccruedFeesForUser(filter: $filter) {
      items {
        ...AccruedFeeFragment
      }
      total
    }
  }
`);

export const FIND_ACCRUED_FEES_FOR_ORG_UNIT = graphql(/* GraphQL */ `
  query findAccruedFees($filter: AccruedFeePagination!) {
    __typename
    findAccruedFees(filter: $filter) {
      items {
        ...AccruedFeeFragment
      }
      total
    }
  }
`);

export function useAccruedFeesForUserQuery(
  matterStatus: MatterStatus = MatterStatus.Live,
  options?: QueryHookOptions<FindAccruedFeesForUserQuery>
) {
  return useQuery(FIND_ACCRUED_FEES_FOR_USER, {
    ...(matterStatus && { variables: { matterStatus } }),
    ...(options || {}),
  });
}
